import React, { useState, useEffect, useContext } from "react";
import { apiGet } from "app/Services/ApiService";
import { employeeApiUrls } from 'common/ApiUrls';

import MessageCarousel from "components/MessageCarousel";

export default function Messages() {
  const [messages, setMessages] = useState(null);
  const [hasInitializationError, setHasInitializationError] = useState(false);

  useEffect(() => {
    apiGet(employeeApiUrls.getMyMessages).then(
      (response) => {
        setMessages(response.data);
        setHasInitializationError(false);
      }
    )
    .catch(e => {
        console.log(e);
        setHasInitializationError(true);
    });
  },[]);

  return (
    <MessageCarousel messages={messages} hasInitializationError={hasInitializationError} />
  );
}
